<!--
  VTextarea

  還原自 index.pretty.js L2014。render function 已轉回 template。

  商品備註輸入框。內容變動時以 update 事件回傳給父元件（VProduct），
  掛載後套用 autoResize 讓高度隨內容增長。
-->

<template>
  <div class="input-area">
    <textarea
      v-model="message"
      class="textarea font-18 js-autoresize"
      :disabled="disabled"
    ></textarea>
  </div>
</template>

<script>
import { autoResize } from '@/utils'

export default {
  props: ['content', 'disabled'],

  data() {
    return { message: this.content }
  },

  watch: {
    message: {
      deep: true,
      handler(value) {
        this.$emit('update', value)
      }
    }
  },

  mounted() {
    autoResize('.js-autoresize')
  }
}
</script>
